/**
 * /* cSpell:disable
 *
 * @format
 */

const ACTIONS_TYPE = {
  CHANGE_USERIMAGE: 'CHANGE_USERIMAGE',
  CHANGE_USERID: 'CHANGE_USERID',
  CHANGE_USER: 'CHANGE_USER',
  LOGOUT: 'LOGOUT',
};
export default ACTIONS_TYPE;
